import React, {useRef, useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import TextBox from "./TextBox";
import {
    TextForm2FlatText,
    getHebrewTextInfo, ReadHebrewText, localStorageSetItem,localStorageGetItem
} from "./misc";
import {useStats} from './StatsContext';
import {removeNekudot} from "./nekudot"


const ExGender = forwardRef(({gameParams, revealed, addHistoryEntry}, ref) => {
        const {
            useStatsUseRef,
            markExDataAsFailure,
            markExDataAsSuccess,
            pickupRandomWordAndForm,
        } = useStats();

        const textType = gameParams.choice[1];

        const textBoxRefs = [useRef(), useRef()];

        // current gameMode
        const gameMode = useRef(gameParams.mode);

        const [currentText, setCurrentText] = useState(() => {
            return JSON.parse(localStorageGetItem('currentText')) || null;
        });

        // Managing the stats
        const statsRefKey = useStatsUseRef(textType, gameParams.mode);

        // This effect is for updating the two TextBox
        useEffect(() => {
            if (currentText === null) return;
            localStorageSetItem('currentText', JSON.stringify(currentText));
            const word = currentText.word;
            const hebrewForm = currentText.hebrewForm;
            const [hebrewText, hebrewPhonetic, frenchText, hebrewTextWithVowels] = currentText.flatText;

            const h = 0;
            const f = 1;

            textBoxRefs[f].current.setFrenchText(frenchText)
            textBoxRefs[h].current.setHebrewText(hebrewTextWithVowels,
                hebrewPhonetic, hebrewForm ? getHebrewTextInfo(word, hebrewForm) : "")

            if (revealed) {
                textBoxRefs[f].current.setShow([]);
                textBoxRefs[h].current.setShow(['info'])
            }
            else {
                textBoxRefs[f].current.setShow([]);
                textBoxRefs[h].current.setShow([])
            }
        }, [currentText, revealed])

        useImperativeHandle(ref, () => ({
            getFlags: () => {
                return {
                    hasRevealPhase: true,
                    hasHistoryButton: true,
                    isReadDisabled: false,
                    isQCM: true
                }
            },
            readHebrewText: () => {
                if (currentText)
                    ReadHebrewText(currentText.flatText[3]);
            },
            isNequdotActive: () => {
                return true
            },
            nequdotClick: (value) => {
                if (value) textBoxRefs[0].current.setShow(["vowels"])
                else textBoxRefs[0].current.setShow([])
            },
            endEx: () => {
                localStorage.removeItem('currentText');
                localStorage.removeItem('textIndex');
            },
            isRecordingDisabled: () => {
                return true;
            },
            isRecordingSuccess: (text) => {
                return true;
            },
            isEndEx: () => {
                return false;
            },
            getQCMList: () => {
                return [ {lang:'h',title: "זכר" }, {lang: 'h', title: "נקבה"}]
            },
            getQCMSolution: () => {
                const solution = Object.keys(currentText.word.formes)[0][0];
                return (solution==='m' ? 0 : 1);
            },
            /* Main function to notify success or failure */
            notifySuccess: (flagSuccess) => {
                let icon;
                if (flagSuccess) {
                    markExDataAsSuccess(statsRefKey, currentText.exData)
                    icon = "✅"
                } else {
                    markExDataAsFailure(statsRefKey, currentText.exData)
                    icon = "❌"
                }

                const [hebrewText, hebrewPhonetic, frenchText, hebrewTextWithVowels] = currentText.flatText;

                addHistoryEntry({
                    text1: removeNekudot(hebrewTextWithVowels) + " " + icon,
                    lang1: 'h',
                    text2: icon + " " + frenchText,
                    lang2: 'f',
                    textWithVowels: hebrewTextWithVowels
                });
            },

            // Function to select the next question
            nextEx: (firstEx = false) => {

                if (currentText && !firstEx) return;

                // WORD CASE
                const [word, hebrewForm] = pickupRandomWordAndForm(statsRefKey, gameParams.texts);
                const mf = hebrewForm[0];
                const exData = word.formes[hebrewForm];
                const flatText = TextForm2FlatText(word, hebrewForm);

                setCurrentText({exData: exData, word: word, hebrewForm: hebrewForm, flatText: flatText});
            }
        }));


        return (
            <div className={"exercice-block"}>
                <div>
                    <TextBox ref={textBoxRefs[0]}/>
                </div>
                <div>
                    <TextBox ref={textBoxRefs[1]}/>
                </div>
            </div>
        )
    }
);


const ExGenderGetInfo = ({action = null, mode = null, choiceIndex = null, texts = null}) => {

    if (action === null) {
        return [
            {
                "title": "Genre",
                "jsname": "ExGenderGetInfo",
                "group": "fm",
                "choices": [["noms communs/propres", "words"]],
                "WordScoreMenuItem": [["Masc./Fém."]],
                "element": ExGender,
                "lessonsExcept": [0],
                "coeff": .2
            }
        ]
    }

    if (action === "filter") {
        if (mode !== "fm") return texts;
        return texts.filter(w => w.cat.includes("nom c.") || w.cat.includes("nom p.")).map(w => {
            const {formes, ...w1 } = w;
            w1.formes = {}
            let form = Object.keys(w.formes)[0][0] + 's'
            if (!(form in w.formes)) form = Object.keys(w.formes)[0][0] + 'p'
            w1.formes[form] = w.formes[form]
            if (w1.formes === null) console.log("BUG",w)
            return w1
        })
    }
}

export {ExGender, ExGenderGetInfo};
